import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.full.text');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-full-text',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.full.text/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.full-text-page {
  min-height: 100%;
  background: rgb(248, 250, 252);
}

.full-text-workspace {
  display: grid;
  grid-template-columns: minmax(16rem, 20rem) minmax(0, 1fr);
  align-items: start;
  overflow: hidden;
  border: 1px solid rgb(226, 232, 240);
  border-radius: 0.875rem;
  background: white;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.document-panel {
  min-width: 0;
  border-right: 1px solid rgb(226, 232, 240);
  background: rgb(248, 250, 252);
}

.document-list {
  max-height: calc(100vh - 20rem);
  min-height: 26rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0.75rem;
}

.document-button {
  display: block;
  width: 100%;
  margin-bottom: 0.5rem;
  border: 1px solid rgb(226, 232, 240);
  border-radius: 0.75rem;
  background: white;
  padding: 0.875rem;
  color: rgb(15, 23, 42);
  transition: border-color 150ms ease, box-shadow 150ms ease, background 150ms ease;
}

.document-button:last-child {
  margin-bottom: 0;
}

.document-button:hover {
  border-color: rgb(165, 180, 252);
  background: rgb(255, 255, 255);
}

.document-button:focus-visible {
  outline: 2px solid rgb(99, 102, 241);
  outline-offset: 2px;
}

.document-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.document-button-selected {
  border-color: rgb(99, 102, 241);
  background: rgb(238, 242, 255);
  box-shadow: inset 3px 0 0 rgb(79, 70, 229);
}

.reader-panel {
  min-width: 0;
  background: white;
}

.version-strip {
  display: flex;
  gap: 0.5rem;
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  padding: 0.125rem 0.125rem 0.5rem;
}

.version-button {
  flex: 0 0 auto;
  min-width: 7.5rem;
  border: 1px solid rgb(203, 213, 225);
  border-radius: 0.625rem;
  background: white;
  padding: 0.625rem 0.75rem;
  text-align: left;
  color: rgb(71, 85, 105);
}

.version-button:hover {
  border-color: rgb(165, 180, 252);
  color: rgb(67, 56, 202);
}

.version-button:focus-visible {
  outline: 2px solid rgb(99, 102, 241);
  outline-offset: 2px;
}

.version-button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.version-button-selected {
  border-color: rgb(79, 70, 229);
  background: rgb(238, 242, 255);
  color: rgb(49, 46, 129);
}

.metadata-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.625rem;
}

.metadata-card {
  min-width: 0;
  border: 1px solid rgb(226, 232, 240);
  border-radius: 0.625rem;
  background: rgb(248, 250, 252);
  padding: 0.75rem;
}

.metadata-card dt {
  color: rgb(100, 116, 139);
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.metadata-card dd {
  margin-top: 0.375rem;
  overflow-wrap: anywhere;
  color: rgb(30, 41, 59);
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.25rem;
}

.metadata-card-wide {
  grid-column: span 3/span 3;
}

.source-reader {
  display: block;
  width: 100%;
  max-height: 58vh;
  min-height: 18rem;
  margin-top: 1rem;
  overflow: auto;
  overscroll-behavior: contain;
  border: 1px solid rgb(203, 213, 225);
  border-radius: 0.75rem;
  background: rgb(248, 250, 252);
  padding: 1.25rem;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  tab-size: 4;
  color: rgb(30, 41, 59);
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.9;
}

.source-reader:focus-visible {
  outline: 2px solid rgb(99, 102, 241);
  outline-offset: 2px;
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid rgb(224, 231, 255);
  border-top-color: rgb(79, 70, 229);
  border-radius: 9999px;
  animation: full-text-spin 700ms linear infinite;
}

@keyframes full-text-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1023px) {
  .full-text-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .document-panel {
    border-right: 0;
    border-bottom: 1px solid rgb(226, 232, 240);
  }
  .document-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-height: 24rem;
    min-height: 0;
    gap: 0.5rem;
  }
  .document-button {
    margin-bottom: 0;
  }
}
@media (max-width: 639px) {
  .document-list {
    display: block;
  }
  .document-button {
    margin-bottom: 0.5rem;
  }
  .metadata-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .metadata-card-wide {
    grid-column: span 1/span 1;
  }
  .source-reader {
    max-height: 65vh;
    min-height: 14rem;
    padding: 1rem;
    font-size: 0.8125rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .loading-spinner {
    animation-duration: 1.5s;
  }
}`],
})
export class PageFullTextComponent implements OnInit {
    public listLoading: boolean = true;
    public detailLoading: boolean = false;
    public ingestionLoading: boolean = false;
    public versionHistoryLoading: boolean = false;
    public listError: string = '';
    public detailError: string = '';
    public versionHistoryError: string = '';
    public ingestionNotice: string = '';
    public documents: any[] = [];
    public selectedDocument: any = null;
    public versions: any[] = [];
    public selectedVersion: any = null;
    public detailPayload: any = null;
    public fullText: string = '';
    public textLoaded: boolean = false;

    private detailRequestSequence: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadDocuments();
    }

    public async loadDocuments() {
        this.listLoading = true;
        this.listError = '';
        await this.service.render();

        try {
            const payload = await this.fetchJson('/api/full-text-documents');
            this.documents = this.toArray(
                payload?.documents
                ?? payload?.items
                ?? payload?.rows
                ?? payload
            );

            if (this.documents.length === 0) {
                this.resetSelection();
                return;
            }

            const previousId = this.documentId(this.selectedDocument);
            const retained = this.documents.find(
                (document) => this.documentId(document) === previousId
            );
            await this.selectDocument(retained || this.documents[0], true);
        } catch (error) {
            this.documents = [];
            this.resetSelection();
            this.listError = this.errorMessage(
                error,
                '전체 원문 문서 목록을 불러오지 못했습니다.'
            );
        } finally {
            this.listLoading = false;
            await this.service.render();
        }
    }

    public async selectDocument(document: any, force: boolean = false) {
        if (!document || this.detailLoading) return;

        const sameDocument = this.documentId(document) === this.documentId(this.selectedDocument);
        if (sameDocument && this.textLoaded && !force) return;

        this.selectedDocument = document;
        this.versions = this.sortVersions(this.documentVersions(document));
        this.selectedVersion = this.currentVersion(this.versions);
        this.detailPayload = null;
        this.fullText = '';
        this.textLoaded = false;
        this.detailError = '';
        this.versionHistoryError = '';
        this.ingestionNotice = '';

        if (this.canIngestDocument(document) && !this.documentHasStoredFullText(document)) {
            this.detailPayload = { document };
            this.textLoaded = true;
            await this.service.render();
            return;
        }

        await this.service.render();
        await this.loadVersionHistory(this.documentId(document));
        await this.loadFullText(this.selectedVersion);
    }

    public async selectVersion(version: any) {
        if (!version || this.detailLoading) return;
        if (
            this.versionKey(version) === this.versionKey(this.selectedVersion)
            && this.textLoaded
        ) return;

        await this.loadFullText(version);
    }

    public async loadOlderVersion() {
        if (!this.hasOlderVersion || this.detailLoading) return;
        await this.selectVersion(this.versions[this.selectedVersionIndex + 1]);
    }

    public async loadNewerVersion() {
        if (!this.hasNewerVersion || this.detailLoading) return;
        await this.selectVersion(this.versions[this.selectedVersionIndex - 1]);
    }

    public async retryDetail() {
        if (!this.selectedDocument || this.detailLoading) return;
        await this.loadFullText(this.selectedVersion);
    }

    public get canIngestSelectedDocument(): boolean {
        return this.canIngestDocument(this.selectedDocument)
            && !this.documentHasStoredFullText(this.selectedDocument);
    }

    public canIngestDocument(document: any): boolean {
        if (!document) return false;
        const available = document?.full_text_available
            ?? document?.metadata?.full_text_available;
        return available === true;
    }

    public documentHasStoredFullText(document: any): boolean {
        if (!document) return false;
        const stored = document?.full_text_stored
            ?? document?.full_text_ingested
            ?? document?.metadata?.full_text_stored
            ?? document?.metadata?.full_text_ingested;
        if (stored === true) return true;
        return this.documentVersionCount(document) > 0;
    }

    public async ingestSelectedDocumentFullText() {
        if (!this.canIngestSelectedDocument || this.ingestionLoading) return;

        const documentId = this.documentId(this.selectedDocument);
        if (!documentId) {
            this.detailError = '전체 원문을 적재할 문서 식별자가 없습니다.';
            await this.service.render();
            return;
        }

        this.ingestionLoading = true;
        this.detailError = '';
        this.ingestionNotice = '';
        await this.service.render();

        try {
            const payload = await this.fetchJson(
                '/api/documents/' + encodeURIComponent(documentId) + '/full-text',
                'POST'
            );
            const returnedDocument = payload?.document || {};
            this.selectedDocument = {
                ...(this.selectedDocument || {}),
                ...returnedDocument,
                full_text_stored: true,
                full_text_ingested: true
            };

            const index = this.documents.findIndex(
                (document) => this.documentId(document) === documentId
            );
            if (index >= 0) this.documents[index] = this.selectedDocument;

            const returnedVersion = this.versionFromPayload(payload);
            this.versions = this.mergeVersionLists(
                this.versions,
                returnedVersion ? [returnedVersion] : []
            );
            this.selectedVersion = this.matchVersion(this.versions, returnedVersion)
                || returnedVersion
                || this.selectedVersion;
            await this.loadFullText(this.selectedVersion);
            await this.loadVersionHistory(documentId);
            if (!this.detailError) {
                this.ingestionNotice = payload?.message
                    || '전체 원문을 원문 보존 규칙에 따라 저장했습니다.';
            }
        } catch (error) {
            this.detailError = this.errorMessage(
                error,
                '전체 원문을 불러와 저장하지 못했습니다.'
            );
        } finally {
            this.ingestionLoading = false;
            await this.service.render();
        }
    }

    private async loadVersionHistory(documentId: string) {
        if (!documentId) return;

        this.versionHistoryLoading = true;
        this.versionHistoryError = '';
        await this.service.render();

        try {
            const payload = await this.fetchJson(
                '/api/documents/' + encodeURIComponent(documentId) + '/versions'
            );
            const returnedVersions = this.toArray(
                payload?.versions
                ?? payload?.items
                ?? payload?.rows
                ?? payload
            );
            if (returnedVersions.length > 0) {
                const previousSelection = this.selectedVersion;
                this.versions = this.mergeVersionLists(
                    this.versions,
                    returnedVersions
                );
                this.selectedVersion = this.matchVersion(
                    this.versions,
                    previousSelection
                ) || this.currentVersion(this.versions);
            }
        } catch (_error) {
            this.versionHistoryError =
                '버전 이력 조회에 실패했습니다. 현재 원문은 계속 확인할 수 있습니다.';
        } finally {
            this.versionHistoryLoading = false;
            await this.service.render();
        }
    }

    private async loadFullText(requestedVersion: any = null) {
        const documentId = this.documentId(this.selectedDocument);
        if (!documentId) {
            this.detailError = '전체 원문을 조회할 문서 식별자가 없습니다.';
            await this.service.render();
            return;
        }

        const requestSequence = ++this.detailRequestSequence;
        this.detailLoading = true;
        this.detailError = '';
        this.fullText = '';
        this.textLoaded = false;
        this.selectedVersion = requestedVersion || this.selectedVersion;
        await this.service.render();

        try {
            const parameters = new URLSearchParams();
            const requestedVersionId = this.versionRequestId(requestedVersion);
            if (requestedVersionId) parameters.set('version_id', requestedVersionId);

            const query = parameters.toString();
            const payload = await this.fetchJson(
                '/api/documents/' + encodeURIComponent(documentId) + '/full-text'
                + (query ? '?' + query : '')
            );
            if (requestSequence !== this.detailRequestSequence) return;

            this.detailPayload = payload || {};
            this.selectedDocument = {
                ...(this.selectedDocument || {}),
                ...(payload?.document || {})
            };

            const embeddedVersions = this.toArray(
                payload?.versions
                ?? payload?.document_versions
                ?? payload?.history
            );
            const returnedVersion = this.versionFromPayload(payload);
            const baseVersions = embeddedVersions.length > 0
                ? embeddedVersions
                : this.versions.length > 0
                    ? this.versions
                    : this.documentVersions(this.selectedDocument);
            this.versions = this.mergeVersions(baseVersions, returnedVersion);

            this.selectedVersion = this.matchVersion(
                this.versions,
                returnedVersion || requestedVersion
            ) || returnedVersion || requestedVersion || this.currentVersion(this.versions);

            this.fullText = this.extractFullText(payload, this.selectedVersion);
            this.textLoaded = true;
        } catch (error) {
            if (requestSequence !== this.detailRequestSequence) return;
            this.detailPayload = null;
            this.fullText = '';
            this.textLoaded = false;
            this.detailError = this.errorMessage(
                error,
                '선택한 원문 버전을 불러오지 못했습니다.'
            );
        } finally {
            if (requestSequence === this.detailRequestSequence) {
                this.detailLoading = false;
                await this.service.render();
            }
        }
    }

    public isDocumentSelected(document: any): boolean {
        return this.documentId(document) === this.documentId(this.selectedDocument);
    }

    public documentButtonClass(document: any): string {
        if (this.isDocumentSelected(document)) {
            return 'document-button document-button-selected';
        }
        return 'document-button';
    }

    public documentId(document: any): string {
        return String(
            document?.id
            ?? document?.document_id
            ?? document?.source_document_id
            ?? document?.external_id
            ?? ''
        );
    }

    public documentTitle(document: any = this.selectedDocument): string {
        return String(
            document?.title
            ?? document?.document_title
            ?? document?.book_title
            ?? '제목 정보 없음'
        );
    }

    public documentAuthor(document: any = this.selectedDocument): string {
        return String(
            document?.author
            ?? document?.metadata?.author
            ?? '저자 정보 없음'
        );
    }

    public documentYear(document: any = this.selectedDocument): string {
        const value = document?.publication_year
            ?? document?.year
            ?? document?.metadata?.publication_year;
        return this.hasValue(value) ? String(value) : '발행연도 정보 없음';
    }

    public documentLanguage(document: any = this.selectedDocument): string {
        const value = document?.language ?? document?.metadata?.language;
        return this.hasValue(value) ? String(value) : '언어 정보 없음';
    }

    public documentSource(document: any = this.selectedDocument): string {
        const value = document?.data_source_name
            ?? document?.source_name
            ?? document?.source?.name
            ?? document?.data_source_id
            ?? document?.metadata?.data_source_name;
        return this.hasValue(value) ? String(value) : '출처 정보 없음';
    }

    public documentVersionCount(document: any): number {
        const direct = Number(
            document?.version_count
            ?? document?.full_text_version_count
            ?? this.documentVersions(document).length
            ?? 0
        );
        return Number.isFinite(direct) && direct >= 0 ? Math.floor(direct) : 0;
    }

    public documentContentLabel(document: any): string {
        const complete = document?.is_complete_text
            ?? document?.full_text_is_complete
            ?? document?.metadata?.is_complete_text;
        if (this.documentHasStoredFullText(document) || complete === true) {
            return '전체 원문';
        }
        if (this.canIngestDocument(document)) return '전체 원문 적재 가능';
        if (this.recordIsSearchExcerpt(document)) return '검색 발췌문';
        return '원문 상태 확인 필요';
    }

    public documentIsSearchExcerpt(document: any): boolean {
        return this.recordIsSearchExcerpt(document);
    }

    public documentContentClass(document: any): string {
        const label = this.documentContentLabel(document);
        if (label === '전체 원문') {
            return 'bg-emerald-50 text-emerald-700 ring-emerald-600/20';
        }
        if (label === '전체 원문 적재 가능') {
            return 'bg-indigo-50 text-indigo-700 ring-indigo-600/20';
        }
        if (this.recordIsSearchExcerpt(document)) {
            return 'bg-amber-50 text-amber-800 ring-amber-600/20';
        }
        return 'bg-slate-100 text-slate-600 ring-slate-500/20';
    }

    public get selectedVersionIndex(): number {
        const selectedKey = this.versionKey(this.selectedVersion);
        if (!selectedKey) return -1;
        return this.versions.findIndex(
            (version) => this.versionKey(version) === selectedKey
        );
    }

    public get hasOlderVersion(): boolean {
        const index = this.selectedVersionIndex;
        return index >= 0 && index < this.versions.length - 1;
    }

    public get hasNewerVersion(): boolean {
        return this.selectedVersionIndex > 0;
    }

    public isVersionSelected(version: any): boolean {
        return this.versionKey(version) === this.versionKey(this.selectedVersion);
    }

    public versionButtonClass(version: any): string {
        if (this.isVersionSelected(version)) {
            return 'version-button version-button-selected';
        }
        return 'version-button';
    }

    public versionKey(version: any): string {
        if (!version) return '';
        return String(
            version?.id
            ?? version?.version_id
            ?? version?.full_text_version_id
            ?? version?.version_no
            ?? version?.version
            ?? version?.source_version
            ?? ''
        );
    }

    public versionLabel(version: any = this.selectedVersion): string {
        const value = version?.version_label
            ?? version?.version_no
            ?? version?.version
            ?? version?.source_version;
        if (!this.hasValue(value)) return '버전 정보 없음';
        const text = String(value);
        return /^v/i.test(text) ? text : 'v' + text;
    }

    public versionStateLabel(version: any = this.selectedVersion): string {
        const isCurrent = version?.is_current
            ?? version?.current
            ?? version?.status === 'current';
        if (isCurrent === true) return '현재 버전';
        if (version?.superseded_at || version?.status === 'superseded') return '이전 보존 버전';
        return '보존 버전';
    }

    public versionTimestamp(version: any = this.selectedVersion): string {
        const value = version?.ingested_at
            ?? version?.created_at
            ?? version?.version_created_at
            ?? version?.updated_at;
        if (!this.hasValue(value)) return '저장 시각 정보 없음';

        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        return new Intl.DateTimeFormat('ko-KR', {
            dateStyle: 'medium',
            timeStyle: 'short'
        }).format(date);
    }

    public contentTypeLabel(): string {
        if (this.isSearchExcerpt) return '검색 발췌문';
        if (this.isCompleteText) return '전체 원문';
        if (this.isSourceTruncated) return '불완전 원문';
        return '원문 상태 확인 필요';
    }

    public contentTypeClass(): string {
        if (this.isSearchExcerpt) {
            return 'bg-amber-50 text-amber-800 ring-amber-600/20';
        }
        if (this.isCompleteText) {
            return 'bg-emerald-50 text-emerald-700 ring-emerald-600/20';
        }
        return 'bg-slate-100 text-slate-700 ring-slate-500/20';
    }

    public get isSearchExcerpt(): boolean {
        return this.recordIsSearchExcerpt(this.selectedVersion)
            || this.recordIsSearchExcerpt(this.detailPayload)
            || this.recordIsSearchExcerpt(this.detailPayload?.document)
            || this.recordIsSearchExcerpt(this.selectedDocument);
    }

    public get isCompleteText(): boolean {
        if (this.isSearchExcerpt) return false;
        const explicit = this.recordValue(
            'is_complete_text',
            'full_text_is_complete'
        );
        if (explicit !== undefined && explicit !== null) return explicit === true;

        const type = this.normalizedContentType();
        return type === 'source_full_text' || type === 'full_text';
    }

    public get isSourceTruncated(): boolean {
        const explicit = this.recordValue(
            'is_source_truncated',
            'source_truncated'
        );
        if (explicit !== undefined && explicit !== null) return explicit === true;
        return this.isSearchExcerpt;
    }

    public get fullTextAvailable(): boolean {
        const explicit = this.recordValue(
            'full_text_available',
            'text_available'
        );
        if (explicit === false && !this.isSearchExcerpt) return false;
        return this.fullText.length > 0;
    }

    public readerTitle(): string {
        if (this.isSearchExcerpt) return '검색 발췌문';
        if (this.isCompleteText) return '전체 원문';
        return '저장된 원문';
    }

    public limitationReason(): string {
        if (this.canIngestSelectedDocument) {
            return '현재 저장본은 전체 원문이 아닙니다. 자료함 상세 원문을 불러와 별도 버전으로 저장할 수 있습니다.';
        }
        const value = this.recordValue('limitation_reason');
        if (this.hasValue(value)) return String(value);
        if (this.isSearchExcerpt) {
            return '외부 자료가 전체 원문이 아닌 검색 발췌문만 제공했습니다.';
        }
        if (!this.fullTextAvailable) {
            return '이 버전의 원문 본문을 사용할 수 없습니다.';
        }
        return '';
    }

    public pageAvailabilityLabel(): string {
        const start = this.recordValue(
            'source_page_start',
            'page_start',
            'start_page'
        );
        const end = this.recordValue(
            'source_page_end',
            'page_end',
            'end_page'
        );
        const single = this.recordValue(
            'source_page',
            'page',
            'page_number'
        );

        if (this.hasValue(start) && this.hasValue(end)) {
            if (String(start) === String(end)) return String(start) + '쪽';
            return String(start) + '–' + String(end) + '쪽';
        }
        if (this.hasValue(start)) return String(start) + '쪽부터 · 끝 페이지 정보 없음';
        if (this.hasValue(end)) return '시작 페이지 정보 없음 · ' + String(end) + '쪽까지';
        if (this.hasValue(single)) return String(single) + '쪽';
        return '원본 페이지 정보 없음';
    }

    public hasPageInformation(): boolean {
        return this.pageAvailabilityLabel() !== '원본 페이지 정보 없음';
    }

    public sourceReferenceLabel(): string {
        const value = this.recordValue(
            'source_reference',
            'source_uri',
            'external_id',
            'archive_document_id'
        );
        return this.hasValue(value) ? String(value) : '원본 식별자 정보 없음';
    }

    public textLengthLabel(): string {
        const value = this.recordValue(
            'full_text_length',
            'full_text_char_count',
            'character_count',
            'text_length'
        );
        const parsed = Number(value);
        const length = Number.isFinite(parsed) && parsed >= 0
            ? parsed
            : this.fullText.length;
        return Math.floor(length).toLocaleString('ko-KR') + '자';
    }

    public textHashLabel(): string {
        const value = this.recordValue(
            'full_text_sha256',
            'content_sha256',
            'sha256',
            'text_hash'
        );
        return this.hasValue(value) ? String(value) : '해시 정보 없음';
    }

    public versionTestId(version: any): string {
        return 'full-text-version-' + this.versionKey(version).replace(/[^a-zA-Z0-9_-]/g, '-');
    }

    public documentTestId(document: any): string {
        return 'full-text-document-' + this.documentId(document).replace(/[^a-zA-Z0-9_-]/g, '-');
    }

    public trackDocument(index: number, document: any): string {
        return String(
            document?.id
            ?? document?.document_id
            ?? document?.source_document_id
            ?? document?.external_id
            ?? index
        );
    }

    public trackVersion(index: number, version: any): string {
        return String(
            version?.id
            ?? version?.version_id
            ?? version?.full_text_version_id
            ?? version?.version_no
            ?? version?.version
            ?? version?.source_version
            ?? index
        );
    }

    private resetSelection() {
        this.detailRequestSequence += 1;
        this.selectedDocument = null;
        this.versions = [];
        this.selectedVersion = null;
        this.detailPayload = null;
        this.fullText = '';
        this.textLoaded = false;
        this.detailLoading = false;
        this.ingestionLoading = false;
        this.versionHistoryLoading = false;
        this.detailError = '';
        this.versionHistoryError = '';
        this.ingestionNotice = '';
    }

    private async fetchJson(url: string, method: 'GET' | 'POST' = 'GET'): Promise<any> {
        const response = await fetch(url, {
            method,
            headers: {
                'Accept': 'application/json'
            },
            cache: 'no-store',
            credentials: 'same-origin'
        });

        let payload: any = null;
        try {
            payload = await response.json();
        } catch (_error) {
            payload = null;
        }

        if (!response.ok) {
            const message = typeof payload === 'string'
                ? payload
                : payload?.message
                    || payload?.detail
                    || payload?.data?.message
                    || payload?.data?.detail;
            throw new Error(
                message || '요청을 처리하지 못했습니다. (HTTP ' + response.status + ')'
            );
        }

        if (
            payload
            && typeof payload === 'object'
            && !Array.isArray(payload)
            && Object.prototype.hasOwnProperty.call(payload, 'data')
        ) {
            return payload.data;
        }
        return payload;
    }

    private extractFullText(payload: any, version: any): string {
        const fullTextValue = payload?.full_text;
        if (typeof fullTextValue === 'string') return fullTextValue;
        if (fullTextValue && typeof fullTextValue === 'object') {
            const nested = fullTextValue?.full_text
                ?? fullTextValue?.text
                ?? fullTextValue?.content;
            if (typeof nested === 'string') return nested;
        }

        const candidates = [
            payload?.text,
            payload?.content,
            payload?.source_text,
            version?.full_text,
            version?.text,
            version?.content,
            payload?.document?.full_text
        ];
        const found = candidates.find((value) => typeof value === 'string');
        return typeof found === 'string' ? found : '';
    }

    private versionFromPayload(payload: any): any {
        const candidates = [
            payload?.version,
            payload?.full_text_version,
            payload?.selected_version,
            payload?.current_version
        ];
        return candidates.find(
            (candidate) => candidate && typeof candidate === 'object'
        ) || null;
    }

    private documentVersions(document: any): any[] {
        return this.toArray(
            document?.versions
            ?? document?.full_text_versions
            ?? document?.version_history
        );
    }

    private mergeVersionLists(existing: any[], incoming: any[]): any[] {
        const merged = [...existing];
        for (const version of incoming) {
            const key = this.versionKey(version);
            const index = merged.findIndex(
                (item) => this.versionKey(item) === key
            );
            if (index >= 0) merged[index] = { ...merged[index], ...version };
            else merged.push(version);
        }
        return this.sortVersions(merged);
    }

    private mergeVersions(versions: any[], returnedVersion: any): any[] {
        const merged = [...versions];
        if (returnedVersion) {
            const key = this.versionKey(returnedVersion);
            const index = merged.findIndex(
                (version) => this.versionKey(version) === key
            );
            if (index >= 0) merged[index] = { ...merged[index], ...returnedVersion };
            else merged.push(returnedVersion);
        }
        return this.sortVersions(merged);
    }

    private sortVersions(versions: any[]): any[] {
        return [...versions].sort((left, right) => {
            const leftCurrent = left?.is_current === true || left?.status === 'current';
            const rightCurrent = right?.is_current === true || right?.status === 'current';
            if (leftCurrent !== rightCurrent) return leftCurrent ? -1 : 1;

            const leftNumber = Number(left?.version_no ?? left?.version ?? left?.source_version);
            const rightNumber = Number(right?.version_no ?? right?.version ?? right?.source_version);
            if (Number.isFinite(leftNumber) && Number.isFinite(rightNumber)) {
                return rightNumber - leftNumber;
            }

            const leftDate = Date.parse(left?.created_at ?? left?.ingested_at ?? '') || 0;
            const rightDate = Date.parse(right?.created_at ?? right?.ingested_at ?? '') || 0;
            return rightDate - leftDate;
        });
    }

    private currentVersion(versions: any[]): any {
        return versions.find(
            (version) => version?.is_current === true || version?.status === 'current'
        ) || versions[0] || null;
    }

    private matchVersion(versions: any[], target: any): any {
        const key = this.versionKey(target);
        if (!key) return null;
        return versions.find((version) => this.versionKey(version) === key) || null;
    }

    private versionRequestId(version: any): string {
        if (!version) return '';
        return String(
            version?.id
            ?? version?.version_id
            ?? version?.full_text_version_id
            ?? version?.version_no
            ?? version?.version
            ?? ''
        );
    }

    private recordIsSearchExcerpt(record: any): boolean {
        if (!record) return false;
        const type = String(
            record?.content_type
            ?? record?.full_text_content_type
            ?? record?.metadata?.content_type
            ?? ''
        ).toLowerCase();
        return type === 'search_excerpt'
            || type === 'excerpt'
            || type.indexOf('search_excerpt') >= 0;
    }

    private normalizedContentType(): string {
        const value = this.recordValue(
            'content_type',
            'full_text_content_type'
        );
        return String(value || '').toLowerCase();
    }

    private recordValue(...keys: string[]): any {
        const records = [
            this.selectedVersion,
            this.detailPayload?.full_text_version,
            this.detailPayload,
            this.selectedDocument
        ];

        for (const record of records) {
            if (!record || typeof record !== 'object') continue;
            for (const key of keys) {
                if (record[key] !== undefined && record[key] !== null) {
                    return record[key];
                }
                if (
                    record.metadata
                    && record.metadata[key] !== undefined
                    && record.metadata[key] !== null
                ) {
                    return record.metadata[key];
                }
            }
        }
        return undefined;
    }

    private hasValue(value: any): boolean {
        return value !== undefined && value !== null && String(value).trim() !== '';
    }

    private toArray(value: any): any[] {
        if (Array.isArray(value)) return value;
        if (Array.isArray(value?.items)) return value.items;
        if (Array.isArray(value?.rows)) return value.rows;
        return [];
    }

    private errorMessage(error: any, fallback: string): string {
        const message = error instanceof Error ? error.message : '';
        return message || fallback;
    }
}

export default PageFullTextComponent;